import React, { useMemo } from 'react';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridTextSorter } from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import PropTypes from 'prop-types';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { useTranslation } from 'react-i18next';

const DepartmentsTable = ({ departments, onDetailClick, onPreviewClick }) => {
  const { t } = useTranslation();
  const titleSkTextFilterProps = useDataGridTextFilter('title_sk');
  const titleEnTextFilterProps = useDataGridTextFilter('title_en');

  const columns = useMemo(
    () => [
      {
        title: t('Názov (slovensky)'),
        dataIndex: 'title_sk',
        ellipsis: true,
        defaultSortOrder: 'ascend',
        sorter: dataGridTextSorter('title_sk'),
        ...titleSkTextFilterProps,
      },
      {
        title: t('Názov (anglicky)'),
        dataIndex: 'title_en',
        ellipsis: true,
        sorter: dataGridTextSorter('title_en'),
        ...titleEnTextFilterProps,
      },
    ],
    [titleSkTextFilterProps, titleEnTextFilterProps, t],
  );

  return (
    <>
      <DataGrid
        rowKey={(department) => department.id}
        columns={columns}
        dataSource={departments || []}
        permissionsBasic={'departments'}
        uniqueTableId={'departments-table'}
        onRowClick={(record) => onDetailClick(record.code)}
        onEditClick={(record) => onDetailClick(record.code)}
        onPreviewClick={onPreviewClick}
        linkToPreview={(index) =>
          `${routes.departments}/${departments[index].code}`
        }
      />
    </>
  );
};

DepartmentsTable.propTypes = {
  departments: PropTypes.array,
  onDetailClick: PropTypes.func,
};

export default DepartmentsTable;
